import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Paper, Grid, styled, Typography, Divider, Collapse, Tooltip } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import {
  getEvaluationTemplateById,
  EvaluationTamplateDTO,
  createEvaluationdFeedback,
  EvaluationFeedbackDTO,
  postEvaluationTemplateList,
  IInterviewerEvaluate,
  IInterviewerEvaluateName,
  getEvaluationTemplateByJobId,
  getJobByJobCode,
  postEvaluatedLink,
  getEvaluationResponseByInvitationId,
  getTemplateById,
  getMappingsByCandidateID,
  inviteShareCandidateUsers,
  updateCandidateSubmission,
} from 'wisestep-api';
import {
  Item,
  WsButton,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  getDateUsingFormat,
  formattedDateISO,
  WsColors,
} from 'wisestep-base';

import {
  useDefaultSmtpEmail,
  useSurveyLogoUrl,
} from '../../../../../components/SurveyBuilder/SurveyCommonMethods';
import SurveyFeedComponent from '../../../../../components/SurveyBuilder/SurveyFeedComponent';
import { BlankTemplateStyledBox } from '../../../../../components/TemplateStyled/CommonTemplateStled';
import { useUserContext, useWorkspaceContext } from '../../../../../context/index';
import { useCandidateViewData } from '../../../../../features/candidateLayout/utils/CandidateViewContext';
import NoEvaluation from '../../../../../images/NoEvaluation.svg';
import { useNotificationStore } from '../../../../../utils/NotificationStore';
import { success, warning } from '../../.././../../utils/NotificationMessages';

import AddEditAssociate from './../../../../conversationWidget/components/AssociateDialog';
import ShareCandidate from './../../../../conversationWidget/components/ShareCandidate';
import SubmissionCandidateEvalutationView from './../../../../conversationWidget/components/SubmissionCandidateEvalutationView';

const GridItem = styled(Item)(() => ({
  padding: '0 0 10px 0',
}));

interface ISubmissionCandiateReview {
  candidiateId?: string | null;
  candidiateData?: any;
  currentJobCode?: string | null;
  templateId?: string | null;
  flag?: boolean;
}

interface EvalTemp {
  createdOn: string;
  email: string;
  feedbackGivenBy: string | null;
  feedbackGivenByName: string | null;
  hasEvaluated: boolean;
  inviteId: string;
  name: string;
  updatedOn: string | null;
}

interface JobCandidateInteraction {
  id: string;
  applicationStage: string;
  applicationState: string;
  candidateNotes: { createdAt: string; createdBy?: string; notes: string }[];
  stageAndStateActions?: {
    stage: string;
    state: string;
    id: string;
    updatedBy: string;
    updatedOn: string;
  }[];
  stageDate?: string | null;
  candidateId: string;
  name: string;
  page: number;
}

const jobCandidateInteraction: JobCandidateInteraction = {
  id: '',
  applicationStage: '',
  applicationState: '',
  candidateNotes: [{ notes: '', createdBy: '', createdAt: '' }],
  stageAndStateActions: {
    stage: '',
    state: '',
    id: '',
    updatedBy: '',
    updatedOn: new Date().toString(),
  },
  candidateId: '',
  name: '',
  page: 0,
};

export const evaluationFeedbackDTOHelper: EvaluationFeedbackDTO = {
  id: '',
  workspaceId: '',
  createdBy: '',
  createdOn: '',
  updated_on: '',
  template: '',
  updatedBy: '',
  templateId: '',
  candidateId: '',
  workAssignmentId: '',
  answeredBy: '',
  invitationId: '',
  jobId: '',
  name: '',
  feedbackOption: '',
  feedbackStag: '',
  feedbackStatus: '',
};

export const interViewerPayloadHelper: IInterviewerEvaluate = {
  subject: '',
  body: '',
  interactionId: '',
  jobId: '',
  evalTemplateId: '',
  reshareEmailId: '',
};

export const interViewerNamePayloadHelper: IInterviewerEvaluateName = {
  inviteId: '',
  email: '',
  feedbackGivenBy: '',
  feedbackGivenByName: '',
};

const StyledGrid = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
});

const StyledTypography = styled(Typography)({
  color: WsColors.TheBlues400,
  fontWeight: 'bold',
});

const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)({
  color: WsColors.TheBlues400,
});

const StyledKeyboardArrowUpIcon = styled(KeyboardArrowUpIcon)({
  color: WsColors.TheBlues400,
});

const CandidateEvaluation: FC<ISubmissionCandiateReview> = ({
  candidiateId,
  currentJobCode,
  templateId,
  candidiateData,
  flag,
}) => {
  const workspace = useWorkspaceContext();
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [evaluationData, setEvaluationData] = useState<EvaluationTamplateDTO[]>([]);
  const [showSurvey, setShowSurvey] = useState(false);
  const [showFinalFeedBack, setShowFinalFeedBack] = useState(false);

  const [showTemplateList, setShowTemplateList] = useState(true);
  const [getTemplateId, setTemplateId] = useState<string>('');
  const [getInvitationId, setInvitationId] = useState<string>('');
  const [getFeedbackBy, setFeedbackBy] = useState<string>('');
  const [getNameFeedbackBy, setNameFeedbackBy] = useState<string>('');
  const [getInterviwerEmail, setInterviwerEmail] = useState<string>('');
  const [getJobId, setJobId] = useState<string>('');
  const [templateJsonObject, setTemplateJsonObject] = useState<any>('');
  const [associatedJsonObject, setAssociatedJsonObject] = useState<any>('');
  const [getInterviewList, setInterviewList] = useState<any>('');
  const [getTemplateIndex, setTemplateIndex] = useState<any>('');
  const [showViewFeedback, setShowViewFeedback] = useState<boolean>(false);
  const [getFeedbackData, setFeedbackData] = useState<any>('');
  const [showAddFeedback, setShowAddFeedback] = useState<boolean>(true);
  const [isAdminFeedback, setIsAdminFeedback] = useState<boolean>(false);
  const [getAdminInvitationId, setAdminInvitationId] = useState<string>('');
  const [adminFeedbackOn, setAdminFeedbackOn] = useState<any>('');
  const [adminFeedBy, setAdminFeedBy] = useState<any>('');
  const [adminFeedByName, setAdminFeedByName] = useState<any>('');
  const [shareCandidate, setShareCandidate] = useState<boolean>(false);
  const [getViewResponseName, setViewResponseName] = useState<string>('');
  const [getViewResponseDate, setViewResponseDate] = useState<string>('');
  const [adminFeedbackStatus, setAdminFeedbackStatus] = useState<{ [key: number]: boolean }>({});
  const [expandedIndex, setExpandedIndex] = useState<number | string>('');
  const [selectedEvalTempData, updateSelectedEvalTempData] = useState<any>({});
  const [selectedTempData, updatedSelectedTempData] = useState<any>({});
  const fileUrlValue = useSurveyLogoUrl();

  const handleUpcomingToggle = (index: number | string) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? '' : index));
  };

  const loggedInUser = useUserContext().userDTO ?? null;
  const { defaultSmtpEmailValue, preferredProviderId } = useDefaultSmtpEmail();
  const { candidateViewData } = useCandidateViewData();
  const [getSurveyFeedbackPayload, setSurveyFeedbackPayload] = useState<any>('');

  let adminInvitationId: string;

  useEffect(() => {
    (async () => {
      if (candidiateData?.id) {
        const interactionRecord = await getMappingsByCandidateID(
          candidiateData?.id as string,
          candidiateData?.jobId as string
        );
        candidiateData.otherDocuments = interactionRecord.data.otherDocuments;
      }
    })();
  }, [candidiateData, candidiateData?.id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const jobId = await getJobByJobCode(currentJobCode as string);
        setJobId(jobId.data.id);
        const response = await getEvaluationTemplateByJobId(jobId.data.id as string);

        setEvaluationData(response.data);
        if (flag) {
          const index = response.data.findIndex((object) => {
            return (object.templateId = templateId);
          });
          showSharedInterviwerList(Number(index), response.data, jobId.data.id);
        }
      } catch (error) {
        console.error('Error fetching evaluation data:', error);
      }
    };

    fetchData();
  }, [currentJobCode, flag, templateId]);

  useEffect(() => {
    if (!shareCandidate) {
      setShowTemplateList(true);
    }
  }, [shareCandidate]);

  const giveFeedBack = (index: number) => {
    setFeedbackBy(loggedInUser?.email as string);
    setNameFeedbackBy(loggedInUser?.lastName as string);
    setInterviwerEmail(getInterviewList[index].email);
    setInvitationId(getInterviewList[index].inviteId);
    setIsAdminFeedback(false);
    setShowAddFeedback(false);
    setShowViewFeedback(false);
    setShowSurvey(true);
  };
  const viewFeedBack = async (inviteId: string) => {
    const feedbackRes = await getEvaluationResponseByInvitationId(inviteId);
    setViewResponseName(feedbackRes.data.answeredBy);
    setViewResponseDate(feedbackRes.data.answeredOn);
    resultViewFeedback(feedbackRes.data.template);
    setShowSurvey(false);
    setShowAddFeedback(false);
    setShowViewFeedback(true);
  };

  const resultViewFeedback = (templateData: any) => {
    const keys = Object.keys(templateData);
    const feedbackArray = keys.map((ques) => ({
      ques,
      ans: templateData[ques],
    }));
    setFeedbackData(feedbackArray);
  };

  const fullUrl = `${window.location.href}&corphiringTemplate=evalutionTemplate`;

  const callSendReminder = async (email: string, name: string) => {
    const payload = {
      to: [{ name: name, email: email }],
      subject: `Evaluation for ${candidiateData?.mappedJobTitle} || ${candidiateData?.name}`,
      body: '',
      interactionId: candidiateId as string,
      jobId: getJobId,
      evalTemplateId: getTemplateId || null,
      sharedCandidateName: candidiateData?.name,
      sharedJobTitle: candidiateData?.mappedJobTitle,
      recruiterEmail: defaultSmtpEmailValue ?? '',
      logoUrl: fileUrlValue ?? '',
      candidateId: candidateViewData?.candidateId ?? '',
      otherInfo: [
        {
          candidateProfileLink: fullUrl,
          workspaceName: workspace.name,
        },
      ],
      preferredProviderId: preferredProviderId,
    };
    try {
      await inviteShareCandidateUsers(payload);
      setNotification(success(`Reminder has been shared successfully !!`));
    } catch (error) {
      setNotification(warning(`Oops, an error occurred.`));
      console.log('error', error);
    }
  };

  const giveAdminFeedBack = () => {
    setFeedbackBy(loggedInUser?.email as string);
    setNameFeedbackBy(loggedInUser?.lastName as string);
    setInvitationId(adminInvitationId);
    setIsAdminFeedback(true);
    setShowAddFeedback(false);
    setShowViewFeedback(false);
    setShowSurvey(true);
  };

  const showBackInterviewerList = (index) => {
    showSharedInterviwerList(index, '', '');
    setShowSurvey(false);
    setShowViewFeedback(false);
    setShowAddFeedback(true);
  };
  const onFinalFeedBackCancel = () => {
    setShowFinalFeedBack(false);
    setShowAddFeedback(true);
  };

  const onFinalFeedBackSaved = async (data: any, feedbackStatus: boolean) => {
    let editedNote = '';
    adminInvitationId = `${getJobId}_${candidiateId}_${getTemplateId}_admin`;
    const efPayload = { ...evaluationFeedbackDTOHelper };
    efPayload.templateId = getTemplateId;
    efPayload.candidateId = candidiateId as string;
    efPayload.workAssignmentId = getTemplateId;
    efPayload.answeredBy = getFeedbackBy;
    efPayload.jobId = getJobId;
    efPayload.invitationId = getInvitationId;
    efPayload.name = getNameFeedbackBy;
    if (feedbackStatus) {
      efPayload.feedbackOption = data.type;
      efPayload.feedbackStag = data.stage;
      efPayload.feedbackStatus = data.status;
      efPayload.template = getSurveyFeedbackPayload;
    } else {
      efPayload.template = data;
    }

    if (isAdminFeedback) {
      efPayload.invitationId = adminInvitationId;
    }
    try {
      await createEvaluationdFeedback(efPayload);
      setNotification(success(`Feedback has been added successfully !!`));

      if (!isAdminFeedback) {
        const npayload = { ...interViewerNamePayloadHelper };
        npayload.inviteId = getInvitationId;
        npayload.email = getInterviwerEmail;
        npayload.feedbackGivenBy = getFeedbackBy;
        npayload.feedbackGivenByName = getNameFeedbackBy;
        await postEvaluatedLink(npayload);
      }
      if (feedbackStatus) {
        const recruiterName = loggedInUser?.displayName ?? '';
        jobCandidateInteraction.id = candidiateData.id;
        jobCandidateInteraction.applicationStage = data.stage;
        jobCandidateInteraction.applicationState = data.status;
        jobCandidateInteraction.stageDate = data.stageDate;
        editedNote = `Evaluation Response for template ${templateJsonObject?.title} was added by ${recruiterName}`;
        jobCandidateInteraction.candidateNotes = [
          {
            notes: editedNote,
            createdBy: getNameFeedbackBy ?? '',
            createdAt: formattedDateISO(new Date()),
          },
        ];
        jobCandidateInteraction.stageAndStateActions = [
          {
            stage: data.stage,
            state: data.status,
            id: '',
            updatedBy: getNameFeedbackBy ?? '',
            updatedOn: formattedDateISO(new Date()),
          },
        ];
        // await updateJobCandidateNotesStateStage(jobCandidateInteraction);
        await updateCandidateSubmission([jobCandidateInteraction]);
      }
      showSharedInterviwerList(getTemplateIndex, '', '');
      setShowFinalFeedBack(false);
      setShowAddFeedback(true);
    } catch (error: any) {
      setNotification(warning(`Oops , Template's Feedback already exists`));
      console.error('error', error);
    }
  };

  const submitFeedback = async (data: any) => {
    let editedNote = '';
    const currentJob = candidateViewData?.candidate?.allCandidateSubmissions?.filter(
      (submssionObj) => submssionObj?.jobCode === candidiateData.jobCode
    );
    const { modifiedOn = '', id = '' } = currentJob?.[0] ? currentJob[0] : {};
    const { applicationStage = '', applicationState = '' } = candidiateData || {};
    jobCandidateInteraction.applicationStage = applicationStage ? applicationStage : '';
    jobCandidateInteraction.applicationState = applicationState ? applicationState : '';
    jobCandidateInteraction.id = candidiateData.id as string;
    const recruiterName = loggedInUser?.displayName ?? '';
    editedNote = ` Evaluation Response for template ${templateJsonObject?.title} was added by ${recruiterName}`;
    jobCandidateInteraction.candidateNotes = [
      {
        notes: editedNote,
        createdBy: recruiterName as string,
        createdAt: formattedDateISO(new Date()),
      },
    ];
    jobCandidateInteraction.stageAndStateActions = [
      {
        stage: applicationStage ? applicationStage : '',
        state: applicationState ? applicationState : '',
        id: id ? id : '',
        updatedBy: (recruiterName as string) ?? '',
        updatedOn: modifiedOn ? modifiedOn : '',
      },
    ];
    const tempRes = await getTemplateById(evaluationData?.[expandedIndex]?.templateId);
    if (
      !tempRes?.data?.associateStageStatusData ||
      Object.keys(tempRes?.data?.associateStageStatusData)?.length === 0
    ) {
      // await updateJobCandidateNotesStateStage(jobCandidateInteraction);
      await updateCandidateSubmission([jobCandidateInteraction]);
    }

    setSurveyFeedbackPayload(data);
    setShowSurvey(false);
    setShowViewFeedback(false);
    if (associatedJsonObject && Object.keys(associatedJsonObject).length > 0) {
      setShowFinalFeedBack(true);
    } else {
      onFinalFeedBackSaved(data, false);
    }
  };

  const showSharedInterviwerList = async (index: number, eventData: any, jobId: string) => {
    let templateListData, jobIdTemplateList;
    if (evaluationData.length > 0) {
      templateListData = evaluationData;
      jobIdTemplateList = getJobId;
    } else {
      templateListData = eventData;
      jobIdTemplateList = jobId;
    }
    const adminInvitationId = `${jobIdTemplateList}_${candidiateId}_${evaluationData[index].templateId}_admin`;
    setAdminInvitationId(adminInvitationId);
    setTemplateIndex(index);
    const payload = { ...interViewerPayloadHelper };
    payload.evalTemplateId = templateListData[index].templateId;
    payload.interactionId = candidiateId as string;
    payload.jobId = jobIdTemplateList;
    let tempRes: any;
    try {
      const response = await postEvaluationTemplateList(payload);
      const interviewData = response.data;
      if (interviewData?.length > 0) {
        const emailMap = new Map<string, EvalTemp>();
        interviewData.forEach((entry: EvalTemp) => {
          const email = entry.email;
          const existingEntry = emailMap.get(email);
          if (!existingEntry || new Date(entry.createdOn) > new Date(existingEntry.createdOn)) {
            emailMap.set(email, entry);
          }
        });
        setInterviewList(Array.from(emailMap.values()));
      }

      tempRes = await getEvaluationTemplateById(templateListData[index].templateId);
      const adminFeedBack = await getEvaluationResponseByInvitationId(adminInvitationId);
      if (adminFeedBack.data) {
        const newAdminFeedbackStatus = { ...adminFeedbackStatus };
        newAdminFeedbackStatus[index] = true;
        setAdminFeedbackStatus(newAdminFeedbackStatus);
        setAdminFeedbackOn(adminFeedBack.data.answeredOn);
        setAdminFeedBy(adminFeedBack.data.answeredBy);
        setAdminFeedByName(adminFeedBack.data.name);
      }
    } catch (error) {
      console.log('error', error);
    }
    setTemplateId(templateListData[index].templateId);
    setTemplateJsonObject(JSON.parse(JSON.stringify(tempRes.data.template)));
    setAssociatedJsonObject(JSON.parse(JSON.stringify(tempRes.data.associateStageStatusData)));
  };

  const shareEvaluationHandler = async (data: any) => {
    const response = await getTemplateById(data.templateId);
    updatedSelectedTempData(response.data);
    updateSelectedEvalTempData(data);
    setShareCandidate(true);
  };

  return (
    <>
      {showSurvey && (
        <>
          <SurveyFeedComponent
            surveyJson={templateJsonObject}
            feedbackDataBack={submitFeedback}
            callShowBackInterviewerList={() => showBackInterviewerList('')}
          />
        </>
      )}
      {showFinalFeedBack && (
        <>
          <AddEditAssociate
            associateJson={associatedJsonObject}
            onSave={onFinalFeedBackSaved}
            onCancel={onFinalFeedBackCancel}
          />
        </>
      )}
      {showViewFeedback && (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
              mt: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                ml: 1.5,
              }}
            >
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK} bold>
                Submitted by:
              </WsTypography>
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                {adminFeedbackStatus[getTemplateIndex] ? adminFeedByName : getViewResponseName}
              </WsTypography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK} bold>
                Date of Request:
              </WsTypography>
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                {adminFeedbackStatus[getTemplateIndex]
                  ? getDateUsingFormat(adminFeedbackOn, 'DD-MMM-YY')
                  : getDateUsingFormat(getViewResponseDate, 'DD-MMM-YY')}
              </WsTypography>
            </Box>

            <WsButton variant="outlined" size="small" onClick={() => showBackInterviewerList('')}>
              Previous
            </WsButton>
          </Box>

          <>
            <SubmissionCandidateEvalutationView feedbackResponseData={getFeedbackData} />
          </>
        </>
      )}
      {showAddFeedback && (
        <>
          {showTemplateList && (
            <>
              {evaluationData?.length > 0 && (
                <Grid container padding={2}>
                  <Grid item>
                    <StyledTypography variant={WsTypoVariants.SUB_TITLE}>
                      {`Evaluation in Job (${evaluationData.length})`}
                    </StyledTypography>
                  </Grid>
                </Grid>
              )}
              {evaluationData?.length > 0 ? (
                evaluationData.map((evalData, index: number) => (
                  <>
                    <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5, mt: 2 }}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Grid item>
                          <WsTypography variant={WsTypoVariants.TITLE} bold>
                            {evalData.templateName}
                          </WsTypography>
                        </Grid>
                        <Grid container alignItems="center" justifyContent="flex-end" spacing={2}>
                          <Tooltip title="Send request">
                            <Grid item>
                              <WsButton
                                variant="outlined"
                                size="small"
                                onClick={() => shareEvaluationHandler(evalData)}
                              >
                                Share Evaluation
                              </WsButton>
                            </Grid>
                          </Tooltip>
                        </Grid>
                      </Grid>
                      <Box mt={1} p={2} bgcolor={WsColors.White} borderRadius={2}>
                        <Grid container justifyContent="space-between">
                          <Grid item xs={6}>
                            <Grid container alignItems="center">
                              <Box pr={2}>
                                <WsTypography
                                  variant={WsTypoVariants.BODY1}
                                  color={WsTypoColors.BLACK}
                                  bold
                                >
                                  Evaluation Tagged by:
                                </WsTypography>
                              </Box>
                              <WsTypography>{evalData.recruiterName}</WsTypography>
                            </Grid>
                          </Grid>
                          <Grid item xs={6}>
                            <Grid container alignItems="center">
                              <Box pr={2}>
                                <WsTypography
                                  variant={WsTypoVariants.BODY1}
                                  color={WsTypoColors.BLACK}
                                  bold
                                >
                                  Evaluation Tagged on:
                                </WsTypography>
                              </Box>
                              <WsTypography>
                                {getDateUsingFormat(evalData.createdOn ?? '', 'DD-MMM-YY')}
                              </WsTypography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                      {expandedIndex === index && <Divider variant="middle" sx={{ mt: 4 }} />}
                      <Grid
                        item
                        xs={8}
                        mt={2}
                        sx={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleUpcomingToggle(index);
                          showSharedInterviwerList(index, '', '');
                        }}
                      >
                        <StyledGrid>
                          <StyledTypography variant={WsTypoVariants.SUB_TITLE}>
                            {expandedIndex === index ? 'Feedback response' : 'Feedback response'}
                          </StyledTypography>
                          {expandedIndex === index ? (
                            <StyledKeyboardArrowUpIcon />
                          ) : (
                            <StyledKeyboardArrowDownIcon />
                          )}
                        </StyledGrid>
                      </Grid>
                      <Collapse in={expandedIndex === index} timeout="auto" unmountOnExit>
                        <>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                              mb: 2,
                              mt: 2,
                            }}
                          >
                            {!adminFeedbackStatus[index] && (
                              <Box ml={1}>
                                <WsButton size="medium" onClick={giveAdminFeedBack}>
                                  Add recruiter feedback
                                </WsButton>
                              </Box>
                            )}
                          </Box>
                          {adminFeedbackStatus[index] && (
                            <>
                              <Box fontWeight="bold">
                                <WsTypography>Recruiter feedback response</WsTypography>
                              </Box>
                              <Paper variant="outlined" sx={{ borderRadius: 2, p: 2, mt: 2 }}>
                                <WsTypography variant={WsTypoVariants.TITLE} bold>
                                  {adminFeedByName}
                                </WsTypography>
                                <Box mt={1} p={2} bgcolor={WsColors.White} borderRadius={2}>
                                  <Grid container justifyContent="space-between">
                                    <Grid item xs={6}>
                                      <Grid container alignItems="center">
                                        <Box pr={2}>
                                          <WsTypography
                                            variant={WsTypoVariants.BODY1}
                                            color={WsTypoColors.BLACK}
                                            bold
                                          >
                                            Given By :
                                          </WsTypography>
                                        </Box>
                                        <WsTypography>{adminFeedBy}</WsTypography>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={6}>
                                      <Grid container alignItems="center">
                                        <Box pr={2}>
                                          <WsTypography
                                            variant={WsTypoVariants.BODY1}
                                            color={WsTypoColors.BLACK}
                                            bold
                                          >
                                            Date of Request:
                                          </WsTypography>
                                        </Box>
                                        <WsTypography>
                                          {getDateUsingFormat(adminFeedbackOn, 'DD-MMM-YY')}
                                        </WsTypography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} container justifyContent="flex-end">
                                    <WsButton
                                      size="small"
                                      onClick={() => viewFeedBack(getAdminInvitationId)}
                                    >
                                      View Feedback
                                    </WsButton>
                                  </Grid>
                                </Box>
                              </Paper>
                            </>
                          )}
                          {getInterviewList?.length > 0 && (
                            <>
                              <Box mt={2} fontWeight="bold">
                                <WsTypography>Interviewer Feedback List</WsTypography>
                              </Box>
                              {getInterviewList.map((evalList, index: number) => (
                                <>
                                  <Paper variant="outlined" sx={{ borderRadius: 2, p: 2, mt: 2 }}>
                                    <Grid item xs={12} spacing={2} mt={1}>
                                      <Box borderRadius={1.5}>
                                        <GridItem>
                                          <Grid container sx={{ mt: 0.3 }}>
                                            <Grid md={12} p={0.5} display="flex">
                                              <Grid md={4}>
                                                <WsTypography color={WsTypoColors.SECONDARY}>
                                                  Evaluation Shared With :
                                                </WsTypography>
                                              </Grid>
                                              <Grid md={8}>
                                                <WsTypography>{`${evalList?.name}(${evalList?.email})`}</WsTypography>
                                              </Grid>
                                            </Grid>
                                            <Grid md={12} p={0.5} display="flex">
                                              <Grid md={4}>
                                                <WsTypography color={WsTypoColors.SECONDARY}>
                                                  Evaluation Shared On :
                                                </WsTypography>
                                              </Grid>
                                              <Grid md={8}>
                                                <WsTypography>
                                                  {getDateUsingFormat(
                                                    evalList.createdOn,
                                                    'DD-MMM-YY'
                                                  )}
                                                </WsTypography>
                                              </Grid>
                                            </Grid>
                                            {evalList?.hasEvaluated && (
                                              <>
                                                <Grid md={12} p={0.5} display="flex">
                                                  <Grid md={4}>
                                                    <WsTypography color={WsTypoColors.SECONDARY}>
                                                      Evaluation Given By :
                                                    </WsTypography>
                                                  </Grid>
                                                  <Grid md={8}>
                                                    <WsTypography>{`${evalList?.feedbackGivenByName}(${evalList?.feedbackGivenBy})`}</WsTypography>
                                                  </Grid>
                                                </Grid>
                                                <Grid md={12} p={0.5} display="flex">
                                                  <Grid md={4}>
                                                    <WsTypography color={WsTypoColors.SECONDARY}>
                                                      Evaluation Submitted On :
                                                    </WsTypography>
                                                  </Grid>
                                                  <Grid md={8}>
                                                    <WsTypography>
                                                      {getDateUsingFormat(
                                                        evalList.updatedOn,
                                                        'DD-MMM-YY'
                                                      )}
                                                    </WsTypography>{' '}
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid item xs={12} container justifyContent="flex-end">
                                            {evalList.hasEvaluated ? (
                                              <Grid spacing={0.7}>
                                                <WsButton
                                                  size="small"
                                                  onClick={() => viewFeedBack(evalList.inviteId)}
                                                >
                                                  View Feedback
                                                </WsButton>
                                              </Grid>
                                            ) : (
                                              <Grid
                                                xs={12}
                                                display="flex"
                                                justifyContent="flex-end"
                                              >
                                                <Box mr={1}>
                                                  <WsButton
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={() =>
                                                      callSendReminder(
                                                        evalList?.email,
                                                        evalList?.name
                                                      )
                                                    }
                                                  >
                                                    Send Reminder
                                                  </WsButton>
                                                </Box>
                                                <Box>
                                                  <WsButton
                                                    size="small"
                                                    onClick={() => giveFeedBack(index)}
                                                  >
                                                    Add Feedback
                                                  </WsButton>
                                                </Box>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </GridItem>
                                      </Box>
                                    </Grid>
                                  </Paper>
                                </>
                              ))}
                            </>
                          )}
                        </>
                      </Collapse>
                    </Paper>
                  </>
                ))
              ) : (
                <BlankTemplateStyledBox pt={15} pb={15} width={201}>
                  <img src={NoEvaluation} width={140} height={140} alt="emptyEvaluation" />
                  <Box pt={2}>
                    <WsTypography bold>No evaluation template is tagged to the job.</WsTypography>
                  </Box>
                </BlankTemplateStyledBox>
              )}
            </>
          )}
        </>
      )}
      {shareCandidate && candidiateId && (
        <ShareCandidate
          interactionId={candidiateId}
          jobTitle={candidiateData?.mappedJobTitle ?? ''}
          jobCode={candidiateData.jobCode ?? ''}
          name={candidiateData?.name}
          evalTempData={selectedEvalTempData}
          onClose={() => {
            setShareCandidate(false);
          }}
          reset={() => {
            setShareCandidate(false);
            setTimeout(() => setShareCandidate(true), 600);
          }}
          selectedTempData={selectedTempData}
          templateType="evaluation"
        />
      )}
    </>
  );
};

export default CandidateEvaluation;
